export default __webpack_public_path__ + "static/media/finix-challenge.ddd5338f.png";